import React from "react";
import { useSelector } from "react-redux";
// import ArrowSlide from "./ArrowSlide";
import SectionTogglerButton from "./SectionTogglerButton";

function Footer({
  onPressPrevSection,
  onPressNextSection,
  prevContentTitle,
  nextContentTitle,
}) {
  const sections = useSelector((state) => state.ui.sections);
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  return (
    <div className="footer-content">
      <div className="footer-content__left-index" onClick={onPressPrevSection}>
        {/* <div className="border-cutter"></div> */}
        {/* <img
          src={require("../assets/images/arrow-left.png")}
          alt=""
          className="footer-content__arrow"
        /> */}
        {/* <ArrowSlide /> */}
        {/* <span className="footer-content__title">{prevContentTitle}</span> */}
        <SectionTogglerButton prev={true} title={prevContentTitle} />
      </div>
      <div className="footer-content__right-index" onClick={onPressNextSection}>
        {/* <div className="border-cutter"></div> */}
        <SectionTogglerButton title={nextContentTitle} />
        {/* <span className="footer-content__title">{nextContentTitle}</span> */}
        {/* <img
          src={require("../assets/images/arrow-right.png")}
          alt=""
          className="footer-content__arrow"
        /> */}
        {/* <ArrowSlide right={true} /> */}
      </div>
    </div>
  );
}

export default Footer;
